import {
  getStockStatusIndicatorColor,
  getStockStatusText,
} from "@coworker/app/src/components/RoomSettings/Molecules/ArticleStock.helper";
import { useAvailableElevatedStock } from "@coworker/app/src/hooks/useAvailableElevatedStock";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import FixaStatus from "@coworker/apprestructured/src/shared/wrappers/FixaStatus/FixaStatus";
import useTranslation from "../../../../../../packages/locales/translations/util/useTranslation";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { ItemNoAndType } from "@coworker/apprestructured/src/task-management/types/TaskDetailTypes";
import { isFoodArticleHfb } from "@coworker/apprestructured/src/shared/helpers/item.helper";

interface StockStatusProps {
  itemNoAndType: ItemNoAndType;
  hfb?: string;
}

export const StockStatus = ({ itemNoAndType, hfb }: StockStatusProps) => {
  const { t } = useTranslation();

  const fullId = `${itemNoAndType.type}${itemNoAndType.no}`;
  const { available, elevated, loading } = useAvailableElevatedStock(fullId);
  const isFoodArticle = isFoodArticleHfb(hfb);

  const stockStatusColor = getStockStatusIndicatorColor(available, elevated);
  const stockStatusText = getStockStatusText(available, elevated);

  const elevatedStatus = !elevated ? "(0)" : `(${elevated})`;
  const addOnContent = (
    <FixaStatus
      label={`${available} ${elevatedStatus}`}
      variant={stockStatusColor}
      small
    />
  );
  return (
    <FixaListViewItem
      size="medium"
      control="default"
      inset
      controlIcon="chevronRight"
      id="media-placement-group-1"
      title={<FixaText textStyle="Heading.XS">Stock status</FixaText>}
      description={isFoodArticle ? "-" : t(stockStatusText)}
      addOn={
        isFoodArticle ? undefined : loading ? t("loadingString") : addOnContent
      }
    ></FixaListViewItem>
  );
};
